import { render, staticRenderFns } from "./SplitPanelModal.vue?vue&type=template&id=dbb7a860&scoped=true&"
import script from "./SplitPanelModal.vue?vue&type=script&lang=js&"
export * from "./SplitPanelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb7a860",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbb7a860')) {
      api.createRecord('dbb7a860', component.options)
    } else {
      api.reload('dbb7a860', component.options)
    }
    module.hot.accept("./SplitPanelModal.vue?vue&type=template&id=dbb7a860&scoped=true&", function () {
      api.rerender('dbb7a860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/modules/SplitPanelModal.vue"
export default component.exports